import React from 'react';

export const ClockSvg: React.FC<React.SVGProps<SVGSVGElement>> = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
  >
    <g clipPath="url(#clip0_23677_21390)">
      <path
        d="M9.49738 8.73642L7.54539 7.27244V4.29027C7.54539 3.99042 7.30302 3.74805 7.00316 3.74805C6.70331 3.74805 6.46094 3.99042 6.46094 4.29027V7.54358C6.46094 7.71437 6.54119 7.87542 6.67783 7.97736L8.84668 9.60401C8.94427 9.67721 9.05816 9.71246 9.17147 9.71246C9.33684 9.71246 9.49951 9.63816 9.6058 9.49502C9.78586 9.25587 9.73705 8.91591 9.49738 8.73642Z"
        fill="#A5A5A5"
      />
      <path
        d="M7 0.5C3.13996 0.5 0 3.63996 0 7.5C0 11.36 3.13996 14.5 7 14.5C10.86 14.5 14 11.36 14 7.5C14 3.63996 10.86 0.5 7 0.5ZM7 13.4156C3.73857 13.4156 1.08443 10.7614 1.08443 7.5C1.08443 4.23857 3.73857 1.58443 7 1.58443C10.262 1.58443 12.9156 4.23857 12.9156 7.5C12.9156 10.7614 10.2614 13.4156 7 13.4156Z"
        fill="#A5A5A5"
      />
    </g>
    <defs>
      <clipPath id="clip0_23677_21390">
        <rect width="14" height="14" fill="white" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
);

export default ClockSvg;
